/* =========================================================
  Plews Tyres México — Product Page JS
========================================================= */
(function(){
  'use strict';
  const roots = document.querySelectorAll('[data-ptp-product-root]');
  if(!roots.length) return;

  roots.forEach((root)=>{
    const productDataEl = root.querySelector('[data-product-json]');
    const variants = productDataEl ? JSON.parse(productDataEl.textContent || '[]') : [];
    const currency = root.dataset.currency || 'MXN';
    const productTitle = root.dataset.productTitle || 'Producto Plews Tyres';
    const waNumber = root.dataset.whatsappNumber || '';
    let selectedOptions = [];
    let selectedVariant = variants.find(v=>v.available) || variants[0] || null;

    const money = (cents)=>{
      const amount = (Number(cents || 0) / 100);
      try { return new Intl.NumberFormat('es-MX',{style:'currency',currency}).format(amount); }
      catch(e){ return '$' + amount.toLocaleString('es-MX') + ' ' + currency; }
    };

    const getSelectedOptionsFromButtons = ()=>{
      const groups = [...root.querySelectorAll('[data-option-index]')];
      return groups.map(group=>{
        const selected = group.querySelector('.ptp-option-btn.is-selected');
        return selected ? selected.dataset.value : '';
      });
    };

    const findVariant = ()=> variants.find(v=>{
      return selectedOptions.every((value,index)=> String(v.options[index]) === String(value));
    });

    const setSlide = (index)=>{
      const slides = [...root.querySelectorAll('[data-slide]')];
      const thumbs = [...root.querySelectorAll('[data-thumb]')];
      if(!slides.length) return;
      const i = (Number(index) + slides.length) % slides.length;
      slides.forEach((s,idx)=>s.classList.toggle('is-active', idx===i));
      thumbs.forEach((t,idx)=>t.classList.toggle('is-active', idx===i));
      root.dataset.currentSlide = String(i);
    };

    const selectVariantMedia = ()=>{
      if(!selectedVariant || !selectedVariant.featured_media) return;
      const target = root.querySelector('[data-slide-media-id="'+ selectedVariant.featured_media.id +'"]');
      if(target){ setSlide(target.dataset.slide); }
    };

    const buildWhatsApp = ()=>{
      if(!waNumber) return '#';
      const qty = root.querySelector('[data-ptp-qty]')?.value || '1';
      const variantLabel = selectedVariant ? selectedVariant.title : selectedOptions.filter(Boolean).join(' / ');
      const msg = `Hola, vengo de la página de producto de Plews Tyres México. Me interesa ${productTitle}. Variante: ${variantLabel}. Cantidad: ${qty}. Quiero confirmar compatibilidad y disponibilidad.`;
      return 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
    };

    const updateUnavailableButtons = ()=>{
      const groups = [...root.querySelectorAll('[data-option-index]')];
      groups.forEach((group, optionIndex)=>{
        group.querySelectorAll('.ptp-option-btn').forEach(btn=>{
          const testOptions = [...selectedOptions];
          testOptions[optionIndex] = btn.dataset.value;
          const match = variants.find(v=> testOptions.every((value,index)=> !value || String(v.options[index]) === String(value)) && v.available);
          btn.classList.toggle('is-unavailable', !match);
        });
      });
    };

    const updateUI = ()=>{
      selectedOptions = getSelectedOptionsFromButtons();
      selectedVariant = findVariant() || selectedVariant;
      const available = !!(selectedVariant && selectedVariant.available);
      const variantIdInput = root.querySelector('[data-variant-id]');
      if(variantIdInput && selectedVariant) variantIdInput.value = selectedVariant.id;

      root.querySelectorAll('[data-ptp-price]').forEach(el=>{ el.textContent = selectedVariant ? money(selectedVariant.price) : ''; });
      root.querySelectorAll('[data-ptp-compare]').forEach(el=>{
        if(selectedVariant && selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price){
          el.textContent = money(selectedVariant.compare_at_price); el.hidden = false;
        } else { el.hidden = true; }
      });
      root.querySelectorAll('[data-ptp-sku]').forEach(el=>{ el.textContent = selectedVariant && selectedVariant.sku ? selectedVariant.sku : 'SKU pendiente'; });
      root.querySelectorAll('[data-option-index]').forEach((group, index) => {
        const label = group.querySelector('[data-selected-option]');
        if(label) label.textContent = selectedOptions[index] || '';
      });
      root.querySelectorAll('[data-ptp-stock]').forEach(el=>{
        el.classList.toggle('is-soldout', !available);
        const qty = selectedVariant && typeof selectedVariant.inventory_quantity !== 'undefined' ? Number(selectedVariant.inventory_quantity) : null;
        el.textContent = available ? (qty !== null && qty > 0 ? `${qty} disponibles` : 'Disponible') : 'Agotado';
      });
      root.querySelectorAll('[data-ptp-submit], [data-ptp-buy-now], [data-ptp-sticky-add]').forEach(btn=>{ btn.disabled = !available; });
      root.querySelectorAll('[data-ptp-wa]').forEach(a=>{ a.href = buildWhatsApp(); });
      updateUnavailableButtons();
      selectVariantMedia();
    };

    root.querySelectorAll('[data-option-index] .ptp-option-btn').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const group = btn.closest('[data-option-index]');
        group.querySelectorAll('.ptp-option-btn').forEach(b=>b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateUI();
      });
    });

    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    root.dataset.currentSlide = '0';
    root.querySelector('[data-ptp-next]')?.addEventListener('click',()=>setSlide(Number(root.dataset.currentSlide || 0)+1));
    root.querySelector('[data-ptp-prev]')?.addEventListener('click',()=>setSlide(Number(root.dataset.currentSlide || 0)-1));
    thumbs.forEach(t=>t.addEventListener('click',()=>setSlide(Number(t.dataset.thumb))));
    if(slides.length) setSlide(0);

    const qty = root.querySelector('[data-ptp-qty]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{ qty.value = Math.max(1, Number(qty.value || 1)-1); updateUI(); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{ qty.value = Number(qty.value || 1)+1; updateUI(); });
    qty?.addEventListener('input',()=>{ if(Number(qty.value) < 1) qty.value = 1; updateUI(); });

    root.querySelectorAll('[data-ptp-buy-now]').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const id = root.querySelector('[data-variant-id]')?.value;
        const quantity = root.querySelector('[data-ptp-qty]')?.value || 1;
        if(!id) return;
        btn.disabled = true;
        try{
          const res = await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)}]})
          });
          if(!res.ok) throw new Error('Cart add failed');
          window.location.href = '/checkout';
        }catch(e){
          btn.disabled = false;
          const form = root.querySelector('[data-ptp-form]');
          form?.submit();
        }
      });
    });

    root.querySelector('[data-ptp-form]')?.addEventListener('submit',(event)=>{
      const submitter = event.submitter;
      if(submitter && submitter.dataset.ptpSubmit !== undefined){
        const old = submitter.textContent;
        setTimeout(()=>{ submitter.textContent = 'Agregando…'; }, 0);
        setTimeout(()=>{ submitter.textContent = old; }, 1600);
      }
    });



    root.querySelectorAll('[data-ptp-sticky-add]').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const id = root.querySelector('[data-variant-id]')?.value;
        const quantity = root.querySelector('[data-ptp-qty]')?.value || 1;
        if(!id) return;
        const old = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Agregando…';
        try{
          const res = await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)}]})
          });
          if(!res.ok) throw new Error('Cart add failed');
          btn.textContent = 'Agregado';
          btn.closest('.ptp-sticky-buy')?.classList.add('is-added');

          try{
            const cartRes = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
            const cart = await cartRes.json();
            document.querySelectorAll('.ptm-cart b, .cart-count-bubble, [data-cart-count]').forEach(el=>{
              el.textContent = cart.item_count;
            });
          }catch(cartError){}

          setTimeout(()=>{
            btn.textContent = old;
            btn.disabled = false;
            btn.closest('.ptp-sticky-buy')?.classList.remove('is-added');
          }, 1800);
        }catch(e){
          btn.textContent = old;
          btn.disabled = false;
          const mainSubmit = root.querySelector('[data-ptp-submit]');
          if(mainSubmit) mainSubmit.click();
        }
      });
    });

    root.querySelectorAll('.ptp-accordion button').forEach(btn=>{
      btn.addEventListener('click',()=> btn.closest('.ptp-accordion')?.classList.toggle('is-open'));
    });

    const reveals = root.querySelectorAll('.ptp-reveal');
    if('IntersectionObserver' in window){
      const io = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){ entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        });
      },{threshold:.14,rootMargin:'0px 0px -60px 0px'});
      reveals.forEach(el=>io.observe(el));
    } else { reveals.forEach(el=>el.classList.add('is-visible')); }

    updateUI();
  });
})();
